// src/hooks/banks/useGetBank.js
import { useQuery } from "@tanstack/react-query";
import { getBank } from "../../api/apiBanks";

function useGetBank(id) {
    const { isLoading, error, data } = useQuery({
        queryKey: ["bank", id],
        queryFn: () => getBank(id),
        enabled: !!id,
    });

    return { isLoading, error, bank: data?.data || null };
}

export default useGetBank;
